import { GET_IPD_ADMISSION_ESTIMATE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import { Receipt } from './getTreatmentPlan';

interface Response {
    success: boolean;
    data: {
        items: AdmissionEstimate[];
        totalBilled?: number;
        totalPaid?: number;
        receipts?: Receipt[];
    };
}

export interface AdmissionEstimate {
    _id: string;
    owner: string;
    name: string;
    admissionid: string;
    service: string;
    rate: number;
    quantity: number;
    discount?: Discount;
    createdAt: string;
    updatedAt: string;
    __v: number;
}

export interface Discount {
    category: string;
    value: number;
}

export default (aid: string): Promise<Response> => {
    return fetchWithRefresh(GET_IPD_ADMISSION_ESTIMATE(aid)).then((res) => res.json());
};
